import React, { useMemo } from "react";
import { Col, Row } from "reactstrap";
import Flatpickr from "react-flatpickr";
import Select from "react-select";
import dayjs from "dayjs";
import { useTranslation } from "react-i18next";
import "dayjs/locale/ru";
import "dayjs/locale/uz";
import "dayjs/locale/uz-latn";
import { getFlatpickrLocale } from "../../utils/flatpickr";

const Section = ({ setDateRange, dateRange }) => {
  const { t, i18n } = useTranslation();

  const monthOptions = useMemo(() => {
    const dayjsLang =
      i18n.language === "uz"
        ? "uz-latn"
        : i18n.language === "uzc"
          ? "uz"
          : (i18n.language === "ru" || i18n.language === "rs")
            ? "ru"
            : "en";
    const capitalizedAll = t("all").charAt(0).toUpperCase() + t("all").slice(1);
    const oldestDate = dayjs().subtract(11, "month").startOf("month");
    const newestDate = dayjs().endOf("month");

    return [
      {
        label: capitalizedAll,
        value: "all-last-12",
        dateFrom: oldestDate.startOf("day").toDate(),
        dateTo: newestDate.endOf("day").toDate(),
      },
      ...Array.from({ length: 12 }, (_, index) => {
        const date = dayjs().subtract(index, "month").locale(dayjsLang);
        const capitalizedMonth = date.format("MMMM").charAt(0).toUpperCase() + date.format("MMMM").slice(1);
        return {
          label: capitalizedMonth + ` ${date.year()}`,
          value: `${date.format("MMMM").toLowerCase()}-${date.year()}`,
          dateFrom: date.startOf("month").toDate(),
          dateTo: date.endOf("month").toDate(),
        };
      }),
    ];
  }, [t, i18n.language]);

  const handleMonthSelect = (option) => {
    if (option) {
      setDateRange([option.dateFrom, option.dateTo]);
    }
  };

  const flatpickrLocale = getFlatpickrLocale(i18n.language);

  return (
    <React.Fragment>
      <Row className="mb-3 pb-1">
        <Col xs={12}>
          <div className="d-flex align-items-lg-center flex-lg-row flex-column gap-2 justify-content-end">
            {/* Month Selector */}
            <div style={{ minWidth: 150 }}>
              <Select
                options={monthOptions}
                placeholder={t("Select months")}
                onChange={handleMonthSelect}
                isClearable
              />
            </div>

            {/* Date Picker */}
            <div>
              <form action="#">
                <Row className="g-3 mb-0 align-items-center">
                  <div className="col-sm-auto">
                    <div className="input-group">
                      <Flatpickr
                        className="form-control border-0 dash-filter-picker shadow"
                        placeholder={t("Select a date")}
                        options={{
                          mode: "range",
                          dateFormat: "d M, Y",
                          locale: flatpickrLocale,
                        }}
                        value={dateRange}
                        onChange={(selectedDates) =>
                          setDateRange(selectedDates)
                        }
                      />
                      <div className="input-group-text bg-primary border-primary text-white">
                        <i className="ri-calendar-2-line"></i>
                      </div>
                    </div>
                  </div>
                </Row>
              </form>
            </div>
          </div>
        </Col>
      </Row>
    </React.Fragment>
  );
};

export default Section;
